"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BloodBeamAbilityHandler = exports.BloodBeamActorAbilityFactory = exports.BloodBeamAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const AbilityDamage_1 = require("../../core/AbilityDamage");
class BloodBeamAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BloodBeam;
        this.__typeName = "BloodBeam";
    }
}
exports.BloodBeamAbilityArgs = BloodBeamAbilityArgs;
let BloodBeamActorAbilityFactory = class BloodBeamActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BloodBeam", "OneEnemies", 0);
    }
};
BloodBeamActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BloodBeam")
], BloodBeamActorAbilityFactory);
exports.BloodBeamActorAbilityFactory = BloodBeamActorAbilityFactory;
let BloodBeamAbilityHandler = class BloodBeamAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const [targetId] = ability.args.target.actorIds;
        container.applyProjectileAttackWithDamage({
            sequence,
            abilityKey: ability.args.__typeName,
            attackType: "ranged",
            attackerId: ability.invokerId,
            targetId,
            projectileType: "RedSolidBeam",
            projectilePath: "line",
            toApply: [
                AbilityDamage_1.AbilityDamage.Power("Physical", 80)
            ],
            onHit(sequence) {
                container.applyDebuff({
                    sequence,
                    attackerId: ability.invokerId,
                    targetId,
                    duration: Duration_1.Duration.Turns(4),
                    effect: new core_1.BleedingEffectArgs("Power", 10)
                });
            },
        });
    }
};
BloodBeamAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BloodBeam)
], BloodBeamAbilityHandler);
exports.BloodBeamAbilityHandler = BloodBeamAbilityHandler;
